import {
  BoldExtension, StrikeExtension, HeadingExtension, ItalicExtension, UnderlineExtension, ImageExtension, BulletListExtension, ListItemExtension, OrderedListExtension, EmojiExtension,
} from 'remirror/extensions';
import emojiData from 'svgmoji/emoji.json';
import { CustomLinkExtension } from './custom/link';

const extensionConstructor = Cls => (options = {}) => new Cls(options);
const defaultExtensions = {
  image: extensionConstructor(ImageExtension),
  heading: extensionConstructor(HeadingExtension),
  link: extensionConstructor(CustomLinkExtension),
  emoji: extensionConstructor(EmojiExtension),
  list: extensionConstructor(ListItemExtension),
  bulletList: extensionConstructor(BulletListExtension),
  orderedList: extensionConstructor(OrderedListExtension),
  bold: extensionConstructor(BoldExtension),
  strike: extensionConstructor(StrikeExtension),
  italic: extensionConstructor(ItalicExtension),
  underline: extensionConstructor(UnderlineExtension),
};

export const DefaultPreset = [
  { name: 'image' },
  { name: 'link', extraAttributes: { target: null } },
  { name: 'heading', config: { levels: [1, 2] } },
  { name: 'emoji', config: { data: emojiData, moji: 'openmoji' } },
];

export default defaultExtensions;
